"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CanvasRenderer = void 0;
const canvas_component_renderer_1 = require("./canvas-component-renderer");
const rc_js_util_1 = require("rc-js-util");
const canvas_component_renderer_provider_1 = require("./canvas-component-renderer-provider");
const canvas_renderer_factory_1 = require("./canvas-renderer-factory");
const canvas_renderer_shared_state_1 = require("./canvas-renderer-shared-state");
const transform_component_store_1 = require("../transform-components/transform-component-store");
const graphics_component_store_1 = require("../graphics-component-store");
/**
 * @public
 * {@inheritDoc ICanvasRenderer}
 */
class CanvasRenderer {
    constructor(context, callbacks) {
        this.graphicsComponents = new graphics_component_store_1.GraphicsComponentStore();
        this.callbacks = {
            onBeforePlotDraw(context, plotDimensions) {
                const plotRange = plotDimensions.pixelArea.wholeRange;
                context.clearRect(plotRange.getXMin() | 0, plotRange.getYMin() | 0, plotRange.getXRange() | 0, plotRange.getYRange() | 0);
            },
            onAfterPlotDraw() {
                // no action needed
            },
        };
        if (callbacks != null) {
            rc_js_util_1._Dictionary.extend(this.callbacks, callbacks);
        }
        this.context = context;
        this.sharedState = new canvas_renderer_shared_state_1.CanvasRendererSharedState(context);
        const { componentRendererFactory, componentRendererProvider } = this.getFactories(context);
        this.componentRendererProvider = componentRendererProvider;
        this.componentRendererFactory = componentRendererFactory;
        this.transformComponents = new transform_component_store_1.TransformComponentStore();
    }
    static createOne(context, callbacks) {
        if (context == null) {
            return null;
        }
        return new CanvasRenderer(context, callbacks);
    }
    onBeforePlotDraw(plot, canvasDims) {
        this.sharedState.onNewFrame();
        this.callbacks.onBeforePlotDraw(this.context, plot.plotDimensionsOTL, canvasDims);
    }
    onAfterPlotDraw() {
        this.callbacks.onAfterPlotDraw(this.context);
    }
    onContextLost() {
        // no action required
    }
    initializeBuffers() {
        // no action required
    }
    destroyBuffers() {
        // no action required
    }
    onContextRegained(context) {
        const { componentRendererFactory, componentRendererProvider } = this.getFactories(context);
        this.sharedState.setContext(context);
        this.componentRendererProvider = componentRendererProvider;
        this.componentRendererFactory = componentRendererFactory;
    }
    getFactories(context) {
        const componentRenderer = new canvas_component_renderer_1.CanvasComponentRenderer(context, this.sharedState);
        return {
            componentRendererProvider: new canvas_component_renderer_provider_1.CanvasComponentRendererProvider(componentRenderer),
            componentRendererFactory: new canvas_renderer_factory_1.CanvasRendererFactory(componentRenderer),
        };
    }
}
exports.CanvasRenderer = CanvasRenderer;
//# sourceMappingURL=canvas-renderer.js.map